<template>
    <div class="Typeahead">
        <input
            class="Input-field"
            id="subject"
            type="text"
            name="subject"

            v-model="subjectInput"
            v-on:keyup="updateSubject"
            v-on:focus="showList = true"
            v-on:blur="blurField($event)"
            autocomplete="off"
            required>
        <input class="Input-field" type="hidden" name="subjectId" :value="subjectInputId">
        <ul id="subjectList" class="Typeahead-dropdown"
            v-if="subjectList.length > 0 && showList">
            <li
                class="Typeahead-dropdownItem"
                v-for="(subject, index) in mutableSubjectList"
                :key="index"
                tabindex="0"
                v-on:click="selectSubject(index)"
                v-on:keyup.enter="selectSubject(index)"
                v-on:focus="cancelListHide">
                <p class="Typeahead-dropdownItem-left">{{ subject.name }}</p>
                <p class="Typeahead-dropdownItem-right">{{subject.date | moment("dddd, D/MM/YYYY, HH:mm")}}</p>
            </li>
        </ul>
        <p
            v-if="errorMessage"
            class="Form-inputError">{{errorMessage}}</p>
    </div>
</template>

<script>
    import './_Typeahead.scss';
    import cookieModel from '../../models/cookie';
    import axios from "axios";

    export default {
        mounted() {
        },
        props: {
            value:  {
                types: [String, Object],
                default: null
            },
            searchUrl: String,
            upcomingOnly: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            getSubjectFromSearch: function() {
                const vm = this;
                let url = this.baseUrl + "/" + vm.searchUrl;

                vm.isLoading = true;

                vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer '+ cookieModel.getCookie('ticketlab_access');

                if (vm.subjectInput === vm.previousSearch) {
                    vm.isLoading = false;
                    return;
                }
                vm.previousSearch = vm.subjectInput;
                let postData = {
                    search: vm.subjectInput,
                    upcomingOnly: vm.upcomingOnly,
                };

                // Get subject for this company
                vm.axiosInstance.post(url, postData)
                    .then(function(response) {
                        if (response.data) {
                            // reset error
                            vm.asyncFormError = false;

                            vm.subjectList = response.data.data;
                            vm.mutableSubjectList = response.data.data;

                            vm.processRetrievedSubject();
                        }
                        vm.isLoading = false;
                    }).catch(function(error) {
                        vm.isLoading = false;
                        if (error.response && error.response.data && error.response.data.reason) {
                            vm.asyncFormError = error.response.data.reason;
                        }
                    });
            },

            blurField: function(event) {
                const vm = this;

                vm.isInDelay = setTimeout(function() {
                    vm.updateSubject(event);
                }, 100);
            },

            updateSubject: function(event) {
                const vm = this;

                vm.$emit('change', event)
                
                // Update subjectInput with the event value
                vm.subjectInput = event.target.value;

                if (vm.subjectInput.length >= 3) {
                    if (!vm.isLoading) {
                        vm.errorMessage = '';
                        vm.getSubjectFromSearch();
                    }
                } else { // Field is empty
                    vm.errorMessage = 'Please enter event name or ID (min. 3 characters)';
                    vm.subjectInputId = '';
                    vm.mutableSubjectList = vm.subjectList;
                    vm.showList = false;
                    vm.$emit('blur', '');
                }
            },

            processRetrievedSubject: function () {
                const vm = this;
                vm.showList = true;

                if (vm.subjectInputId !== '') {
                    const savedSubjectName = vm.subjectList[vm.subjectInputId-1].name;

                    if (vm.subjectInput.startsWith(savedSubjectName)) {
                        vm.subjectInput = savedSubjectName;
                        return;
                    } else {
                        vm.subjectInputId = '';
                    }
                }

                // Search for string in array
                if (vm.mutableSubjectList.length === 0) {
                    vm.errorMessage = 'No matching events found. Please try again';
                    vm.showList = false;
                    vm.$emit('blur', '');
                } else if (vm.mutableSubjectList.length === 1) {
                    vm.errorMessage = '';
                    vm.subjectInputId = vm.mutableSubjectList[0].id;
                    vm.showList = false;
                    vm.$emit('blur', vm.mutableSubjectList[0]);
                } else {
                    // more than 1 result
                    vm.errorMessage = '';
                    vm.showList = true;
                }
            },

            selectSubject: function(thisSubject) {
                let vm = this;

                // If there's a timer present, cancel it
                vm.cancelListHide();

                vm.subjectInput = vm.subjectList[thisSubject].name;
                vm.subjectInputId = vm.subjectList[thisSubject].id;
                vm.mutableSubjectList = [];
                vm.errorMessage = '';
                vm.showList = false;
                vm.$emit('blur', vm.subjectList[thisSubject]);
                vm.$emit('selectedItem', vm.subjectList[thisSubject]);
            },

            hideListWithDelay: function() {
                // Without a delay, the list disappears before we can click it.
                // This function simply keeps the list on the screen long enough to click a table number in the dropdown
                let vm = this;

                setTimeout(function() {
                    vm.showList = false;
                }, 200);
            },

            cancelListHide: function() {
                if (this.isInDelay) {
                    clearTimeout(this.isInDelay);
                    this.isInDelay = undefined;
                }
            }
        },
        data: function () {
            return {
                axiosInstance: axios.create({
                    baseURL: this.baseUrl,
                }),
                baseUrl: process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : '/',
                subjectInput: '',
                previousSearch:'',
                subjectInputId: '',
                errorMessage: '',
                asyncFormError: false,
                mutableSubjectList: [],
                subjectList: [],
                showList: false,
                isInDelay: undefined,
                isLoading: false,
            }
        }
    }
</script>
